export const LOADING_STATUS = {
  INITIAL: 0,
  LOADING: 1,
  SUCCESS: 2,
  FAIL: 3
};

export const ACTIVITY_TYPES = {
  minimal: 'Физическая нагрузка отсутствует или минимальная',
  middle: 'Тренировки средней тяжести 2-3 раза в неделю',
  middle_intensive: 'Тренировки средней тяжести 5 раз в неделю',
  every_day: 'Тренировки каждый день',
  every_day_intensive: 'Интенсивные тренировки каждый день',
  semi_intensive: 'Интенсивные тренировки 5 раза в неделю',
  every_day_hard: 'Ежедневная нагрузка + физическая работа',
};

export const GOAL_TYPES = {
  muscles: 'Набор мышечной массы',
  weight_lose: 'Медленная потеря веса',
  keep_form: 'Поддержание текущей формы'
};
